var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0258 17.1246L16.6483 13.8746L11.0258 10.6246V17.1246ZM23.5492 8.64209C23.69 9.15126 23.7875 9.83376 23.8525 10.7004C23.9283 11.5671 23.9608 12.3146 23.9608 12.9646L24.0258 13.8746C24.0258 16.2471 23.8525 17.9913 23.5492 19.1071C23.2783 20.0821 22.65 20.7104 21.675 20.9813C21.1658 21.1221 20.2342 21.2196 18.8042 21.2846C17.3958 21.3604 16.1067 21.3929 14.915 21.3929L13.1925 21.4579C8.65333 21.4579 5.82583 21.2846 4.70999 20.9813C3.73499 20.7104 3.10666 20.0821 2.83583 19.1071C2.69499 18.5979 2.59749 17.9154 2.53249 17.0488C2.45666 16.1821 2.42416 15.4346 2.42416 14.7846L2.35916 13.8746C2.35916 11.5021 2.53249 9.75793 2.83583 8.64209C3.10666 7.66709 3.73499 7.03876 4.70999 6.76793C5.21916 6.62709 6.15083 6.52959 7.58083 6.46459C8.98916 6.38876 10.2783 6.35626 11.47 6.35626L13.1925 6.29126C17.7317 6.29126 20.5592 6.46459 21.675 6.76793C22.65 7.03876 23.2783 7.66709 23.5492 8.64209Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3470c12a63c7bd1f450bcbe4120d4203.svg";
export { ForwardRef as ReactComponent };